export default __webpack_public_path__ + "static/media/63.f0afe442.png";